import { useEffect, useState } from "preact/hooks";
import { IReponse } from "../../../services/interface";
import { GET, GET_DELIVERY_OPTION } from "../../../services";

interface IDeliveryOption {
  deliveryName: string;
  deliveryId: string;
}

interface IProps {
  deliveryOptions: IDeliveryOption[];
  loading: boolean;
}

export const useGetDeliveryOptions = (): IProps => {
  const [loading, setLoading] = useState(false);
  const [deliveryOptions, setDeliveryOptions] = useState([]);

  const onGetDeliveryOptions = async () => {
    setLoading(true);
    try {
      const res: IReponse = await GET(GET_DELIVERY_OPTION);
      setDeliveryOptions(res.result?.options);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onGetDeliveryOptions();
  }, []);

  return { deliveryOptions, loading };
};
